import React, { useEffect, useRef, useState, useCallback } from 'react';
import axios from 'axios';
import useAuth from '../hooks/useAuth.js';
import useAxiosPrivate from '../hooks/useAxiosPrivate';
import AdminPage from './AdminPage.js';
// css 
import './ComponentsCss/UserInfo.css';
// imgs 
import signImg from "../imgs/sign.png";
import LogoImg from "../imgs/logo-hori.png"
import nameImg from '../imgs/UserInfo/name.png'
import idImg from '../imgs/UserInfo/userId.png'
import emailImg from '../imgs/UserInfo/email.png'
import mobileImg from '../imgs/UserInfo/mobile.png'
import roleImg from '../imgs/UserInfo/role.png'

// logout hook
import useLogout from '../hooks/useLogout.js';

import toast, { Toaster } from 'react-hot-toast';
const errNotify = (Text) => toast.error(Text);
const Notify = (Text) => toast.success(Text);
const UserInfo = () => {
  const { auth, setAuth } = useAuth();

  // gui 
  const [POA, SetPOA] = useState(false);
  const [UserData, SetUserData] = useState();
  const [UserAddress, SetUserAddress] = useState("");
  const axiosPrivate = useAxiosPrivate();

  // modal call back 
  const [AdminPageModalOpen, SetAdminPageModalOpen] = useState(false);
  const [AdminPageData, SetAdminPageData] = useState();

  const AdminPageOpenStateCallBack = useCallback((AdminPageModalOpen) => {
    SetAdminPageModalOpen(AdminPageModalOpen);

  }, [AdminPageModalOpen]);
  const AdminPageDataCallBack = useCallback((AdminPageData) => {
    SetAdminPageData(AdminPageData);
    //alert("Received data " + ModalData);
  }, [AdminPageData]);
  useEffect(() => {
    axiosGetUserInfo();
  }, []);

  const logout = useLogout();
  const signOut = async () => {
    await logout();

  }

  const axiosGetUserInfo = async () => {
    const controller = new AbortController();
    try {
      var DataJson = "";
      DataJson = JSON.stringify({
        userId: auth?.UserId,

      }, null, 2);

      console.log("axiosGetUserInfo  : " + DataJson);
      var finalIP = "";

      finalIP = "https://stepupkorea.kr/api/userInfo";

      const response = await axiosPrivate.post(finalIP,
        DataJson,
        {
          headers: { 'Content-Type': 'application/json' },
          withCredentials: true
        }
      );
      if (response) {

        console.log(" axiosGetUserInfon success::: ", JSON.stringify(response?.data));
        SetUserData(response?.data);
      }



    } catch (err) {

      if (!err?.response) {
        console.log('--No Server Response');
      } else if (err.response?.status === 404) {
        console.log('--No user ID');
      } else if (err.response?.status === 400) {
        console.log('Wrong pass ');

      } else if (err.response?.status === 403) {
        console.log('Access token expire ');
        errNotify("자동 로그아웃됬습니다. 다시 로그인 해주세요.");
        setAuth();
      } else {
        console.log('ERR');
      }

    }
  }
 

 
  return (
    <>
      {
          // admin page modal 
          AdminPageModalOpen ? 
          <AdminPage ModalOpenCallBack={AdminPageOpenStateCallBack} ModalDataCallBack={AdminPageDataCallBack}/> 
          : null 
      }
      {
        POA == false ?
          <>
            <div className='user-info-main-frame'>
              <div className='user-info-flex-row'>
                <img src={nameImg} className='user-info-icon' />
                <div className='user-info-flex-col'>
                  <div className='user-info-grey-text'> 이름</div>
                  <div className='user-info-black-text'>{UserData?.userName}</div>
                  <div className='user-info-separator '></div>
                </div>

              </div>
              <div className='user-info-flex-row'>
                <img src={idImg} className='user-info-icon' />
                <div className='user-info-flex-col'>
                  <div className='user-info-grey-text'> 아이디</div>
                  <div className='user-info-black-text'>{UserData?.userId}</div>
                  <div className='user-info-separator '></div>
                </div>

              </div>
              <div className='user-info-flex-row'>
                <img src={emailImg} className='user-info-icon' />
                <div className='user-info-flex-col'>
                  <div className='user-info-grey-text'> 이메일</div>
                  <div className='user-info-black-text'>{UserData?.userEmail}</div>
                  <div className='user-info-separator '></div>
                </div>

              </div>
              <div className='user-info-flex-row'>
                <img src={mobileImg} className='user-info-icon' />
                <div className='user-info-flex-col'>
                  <div className='user-info-grey-text'> 휴대폰 번호</div>
                  <div className='user-info-black-text'>{UserData?.userMobile}</div>
                  <div className='user-info-separator '></div>
                </div>

              </div>
              <div className='user-info-flex-row'>
                <img src={roleImg} className='user-info-icon' />
                <div className='user-info-flex-col'>
                  <div className='user-info-grey-text'> 계정 타입</div>

                  {auth?.roles[0] == 8521 ?
                    <div className='user-info-black-text'>
                      일반 회원
                    </div>
                    : auth?.roles[0] == 5651 ?
                      <div className='user-info-black-text'>
                        전문 회원
                      </div>
                      : auth?.roles[0] == 5150 ?

                        <div className='user-info-flex-row' style={{ justifyContent: "space-between" }}>
                          <div className='user-info-black-text'>
                            관리자
                          </div>
                          <div className="user-info-right-button" onClick={() => SetAdminPageModalOpen(!AdminPageModalOpen)}> 관리자 콘솔 </div>
                        </div> : null}


                  <div className='user-info-separator '></div>
                </div>

              </div>

              <br />
              <br />
              <br />
              <button className="user-info-right-button" onClick={() => signOut()} >

                로그아웃하기
              </button>
            </div>
            <br />
            <br />
            <br />
            <br />
           
          </>
          :
          null 
      }

    </>
  )
}

/* 
 <div className="input-group" >

              <button className="mobile-button " onClick={() => SetPOA(!POA)}>

                대리인 위임장 작성하기
              </button>

            </div>

*/
export default UserInfo